import {observable} from 'mobx';
import {construct, ModelProperties} from 'utils';

export class LocaleHint {
    @observable id!: number;

    @observable title!: string;

    @observable value!: string;

    constructor(hint?: ModelProperties<LocaleHint>) {
        if (hint) {
            construct(this, hint);
        }
    }
}